define("calendar/models/ig-preview-post", ["exports", "shared/models/ig-preview-post"], function (_exports, _igPreviewPost) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.defineProperty(_exports, "default", {
    enumerable: true,
    get: function () {
      return _igPreviewPost.default;
    }
  });
  0; //eaimeta@70e063a35619d71f0,"shared/models/ig-preview-post"eaimeta@70e063a35619d71f
});